import React, { useState, useEffect } from 'react';
import './HeroBanner.css';

const HeroBanner = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    'https://wallpapers.com/images/featured/tienda-de-ropa-sqy45b7hhimu1de8.jpg',
    'https://www.022estudio.com/wp-content/uploads/2023/03/tiendas-de-ropa-y-retail-como-favorece-el-diseno-a-la-decision-de-compra-022-studio-scaled.jpg',
    'https://cdn.shopify.com/s/files/1/0479/4558/0694/files/chio-lecca-blog-escaparatismo-que-es.jpg?v=1689401697',
  ];

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Efecto para el carrusel automático 
  useEffect(() => {
    const interval = setInterval(nextImage, 5000); // Cambia de imagen cada 5 segundos
    return () => clearInterval(interval);
  },  [currentImageIndex, nextImage]);

  return (
    <div className="hero-banner">
      <div className="carousel-container">
        <img
          src={images[currentImageIndex]}
          alt="Banner promocional"
          className="carousel-image"
        />
        <button className="carousel-arrow left-arrow" onClick={prevImage}>
          &#10094;
        </button>
        <button className="carousel-arrow right-arrow" onClick={nextImage}>
          &#10095;
        </button>
        <div className="carousel-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentImageIndex === index ? 'active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            ></span>
          ))}
        </div>
      </div>

      <div className="banner-content">
        <h1>Importaciones Ropita 🌟</h1>
        <p>Descubre las últimas tendencias en moda importada, calidad y estilo al alcance de tu mano. Renueva tu guardarropa con piezas únicas que marcan la diferencia. ¡Envío rápido a todo el país!</p>
      </div>
    </div>
  );
};

export default HeroBanner;